import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mcommerce-audit-config-breadcrumb-card',
  templateUrl: './mcommerce-audit-config-breadcrumb-card.component.html',
  styleUrls: ['./mcommerce-audit-config-breadcrumb-card.component.scss']
})
export class McommerceAuditConfigBreadcrumbCardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
